import { Box, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SupportTabs from "./components/SupportTabs";
import NewRequestTab from "./components/NewRequestTab";
import MessagesTab from "./components/MessagesTab";
import HelpfulResources from "./components/HelpfulResources";
import PageLayout from "components/layout/PageLayout";
import { useDispatch, useSelector } from "react-redux";
import { clearSupportState } from "../../../store/support/reducer";
import {
  draftsProjectsCntSelector,
  unreadMessageSelector,
} from "store/project/selector";
import { userSelector } from "store/user/selector";
import { getUnreadMessagesRequest } from "store/project/reducer";
import { useSupportUnreadContext } from "contexts/SupportUnreadContext";

const TAB_COMPONENTS: Record<number, React.FC> = {
  0: NewRequestTab,
  1: MessagesTab,
};

export default function Support() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "messages" ? 1 : 0;
  const [activeTab, setActiveTab] = useState(initialTab);
  const { refetch: refetchUnreadCount } = useSupportUnreadContext();

  useEffect(() => {
    if (searchParams.get("tab")) {
      setSearchParams({}, { replace: true });
    }
  }, []);
  
  // Refresh unread count when support page loads
  useEffect(() => {
    refetchUnreadCount();
  }, [refetchUnreadCount]);
  
  const dispatch = useDispatch();

  const unreadMessages = useSelector(unreadMessageSelector);
  const draftsProjectsCnt = useSelector(draftsProjectsCntSelector);
  const user = useSelector(userSelector);

  const unreadMessagesCnt =
    unreadMessages?.reduce(
      (acc: number, currentItem: any) => acc + Number(currentItem.cnt),
      0,
    ) + draftsProjectsCnt;

  const windowLocation = window.location.href;

  useEffect(() => {
    if (user?.user_id) {
      dispatch(getUnreadMessagesRequest({ user_id: Number(user.user_id) }));
    }
  }, [user?.user_id, windowLocation]);

  useEffect(() => {
    return () => {
      dispatch(clearSupportState());
    };
  }, [dispatch]);

  const ActiveComponent = TAB_COMPONENTS[activeTab];

  return (
    <PageLayout>
      <Box mb="24px">
        <Text fontSize="24px" fontWeight="600" color="#0B0E10" mb="4px">
          Get help with your orders
        </Text>
        <Text fontSize="16px" color="#0B0E10">
          We’re here to help. Get assistance with your orders, billing, account,
          or team. You can also contact your dedicated project manager directly.
        </Text>
      </Box>

      <Box bg="white" mb="24px">
        <SupportTabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
          unreadMessagesCnt={unreadMessagesCnt}
        />

        <Box mt="24px">{ActiveComponent && <ActiveComponent />}</Box>
      </Box>

      {activeTab === 0 && <HelpfulResources />}
    </PageLayout>
  );
}
